import { useId } from 'react';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import type { ReportUsersObjectFilter } from '../helper/reportUsersStorage';
import ReportExecutorSelect from '../ReportFilterFields/ReportExecutorSelect';

const OffReportUsersFilterForm = () => {
    const { t } = useTranslation('Reports');
    const { values, setFieldValue } = useFormikContext<{ objectFilter: ReportUsersObjectFilter }>();
    const id = useId();
    return (
        <>
            <div className="mb-3">
                {(['all', 'closed'] as const).map((value) => (
                    <button key={value} type="button" className="off-filter-item" onClick={() => void setFieldValue('objectFilter', value)}>
                        <input type="radio" name={id} className="form-check-input me-2" checked={values.objectFilter === value} readOnly />
                        {t(`usersFilter.${value}`)}
                    </button>
                ))}
            </div>
            <ReportExecutorSelect />
        </>
    );
};

export default OffReportUsersFilterForm;
